module.exports = __webpack_public_path__ + "img/agency_banner_2.22d977c0.png";